import React from "react";
import { Search } from "lucide-react";

/**
 * Filter bar for lists/tables: search + optional chips + right-side actions.
 *
 * <FilterBar
 *   searchValue={q} onSearchChange={setQ} searchPlaceholder="Search orgs"
 *   chips={[{ id: "all", label: "All (12)" }, { id: "active", label: "Active (8)" }]}
 *   activeChip={activeChip} onChipChange={setActiveChip}
 *   right={<Button>New</Button>}
 * />
 */
export default function FilterBar({
  searchValue = "", onSearchChange, searchPlaceholder = "Search…",
  chips = [], activeChip, onChipChange, right, testId,
}) {
  return (
    <div className="hbf-filterbar" data-testid={testId || "filterbar"}>
      {onSearchChange && (
        <div className="hbf-filterbar__search">
          <Search size={14} strokeWidth={2} className="hbf-muted" />
          <input
            type="text"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            className="hbf-filterbar__input"
            data-testid="filterbar-search-input"
          />
        </div>
      )}
      {chips.length > 0 && (
        <div className="hbf-filterbar__chips" role="tablist">
          {chips.map((c) => (
            <button
              key={c.id}
              type="button"
              role="tab"
              aria-selected={activeChip === c.id}
              onClick={() => onChipChange?.(c.id)}
              className={`hbf-chip ${activeChip === c.id ? "is-active" : ""}`}
              data-testid={`filterbar-chip-${c.id}`}
            >
              {c.label}
            </button>
          ))}
        </div>
      )}
      {right && <div className="hbf-filterbar__right">{right}</div>}
    </div>
  );
}
